import { tlResponseToUptimeString, checkBoxToString, Watch, TenantService, MessageService, MessageFilter, ComponentService, AxiosResponse, BaseTLDetailComponent, RightHelper, ObjectTypesHelper, tlISODateTimeToLocalString, tlISODateTimeToLocalNoSecondsString, TenantFilter, tlISOLocalDateTimeToZoneString} from "../../../Infrastructure/CorBase/CoreBase";
import { ContentService, ContentFilter, ReceiverService, VariantService, VariantFilter } from "../../../Services/ContBase/AllConServices";
import TagModal from "../../../Components/ComponentsBase/BaseTLModalDialogTag.vue";
import ModalDetail from "../../../Components/ComponentsBase/BaseTLModalDialogDetail.vue";
	
export default abstract class ReceiverDetailBase extends BaseTLDetailComponent {
	variantService: VariantService = new VariantService();
	contentService: ContentService = new ContentService();
	receiverService: ReceiverService = new ReceiverService();
	componentService: ComponentService = new ComponentService();
	tenantService: TenantService = new TenantService();
	messageService: MessageService = new MessageService();

	protected disableRefreshButton: boolean = false;

	returnRoute: string = "ReceiverList";
	//kdyz se jedna o seznam neprirazenych obrazovek
	notAssigned = false; 
	showParamsDetail = true;

	tenantsAll: [] = [];

	labelWidth = "4";
	inputWidth = "13";

	formDataTenant = {
		idTenant: 0
	}

	timeZoneText = ''; // doplnit ze settingu tenanta nebo podle id z komponenty

	formData = {
		id: 0,
		idTenant: null,
		fileSumCheckTable: '' as string,
		idGroup: null,
		componentId: '',
		name: '',
		description: '',
		isReceiverComponent: false,
		idComponentTypeNavigationName: '',
		idComponentStateNavigationName: '',
		idComponentStateNavigationIdentifier: '',
		portText: '',
		ipaddressLocalText: '',
		ipaddressText: '',
		ipaddressVPNText: '',
		macaddress: '',
		isActive: false,
		isDisabled: false,
		isWaitingForAcceptProvisioning: false,
		isLost: false,
		isDeleted: false,
		idComponent: 0,
		idVariant: 0,
		idVariantText: '',
		idDisplayOrientation: 0,
		idDisplayOrientationText: '',
		enableDisplayTurnOff: null,
		sendPrintScreen: null,
		audioEnabled: null,
		isProcessingTask: false,
		idAudioOutput: 0,
		idLogLevel: 0,
		idTimeZone: 0,
		idContentInBootUpScreen: 0,
		idContentInBootUpScreenText:'',
		idGroupNavigationName: '',
		backgroundColor: '' as string,
		taskActual: null,
		taskCommon: null,
		taskPriority: null,
		taskIdle: null,
		tags: null,
		idAudioOutputText: '',
		idLogLevelText: '',
		idTimeZoneText: '',
		operatingSystem: '',
		connectionState: '',
		connectionStateError: false,
		dotnet: '',
		programVersion: '',
		displayResolution: '',
		storage: '',
		storageData: '',
		cPU: '',
		cPUTemperature: '',
		rAM: '',
		hardwarePlatform: '',
		videoOutput: '',
		audioOutput: '',
		useCPU: '',
		uptime: '',
		cECState: '',
		cECStateAllow: false,
		localTime: '',
		contentInBootUpScreen: null,
		dateOfConfiguration: '',
		adoptionCode: '',
		mtu: null,
		mtuText: ''
	}

	playBase() {
		this.playTaskOnComponent();
	}

	disableResetButton = false;
	disableSoftResetButton = false;
	resetBase() {
		this.disableResetButton = true;
		this.receiverService.reset([this.formData.id]).then(res => {
			this.disableResetButton = false;
		}).catch(error => {
			this.disableResetButton = false;
			var errorText = (error.data.errors as Array<string>).join(" ");
			this.showErrorMessage(errorText);
		});
	}

	useFirst = true;
	idSecondImage = 0;
	idFirstImage = 0;
	refreshClickBase() {
		this.disableRefreshButton = true;
		this.receiverService.getRefreshWithScreenById(this.formData.id).then(res => {
			const id = this.formData.id;
			const prevFileSumCheckTable = this.formData.fileSumCheckTable;
			this.processResponse(res);

			if (prevFileSumCheckTable != this.formData.fileSumCheckTable)
				this.imageSwitch(id);
		}).finally(() => {	
			this.disableRefreshButton = false;
		});
	}

	imageSwitch(id: number, afterCallback: (() => void) | undefined = undefined, timeout: number = 500) {
		setTimeout(() => {
			this.$nextTick(function () {
				if (this.useFirst) {
					this.idSecondImage = id;
					this.useFirst = false;
					this.idFirstImage = 0;
				} else {
					this.idFirstImage = id;
					this.useFirst = true;
					this.idSecondImage = 0;
				}
				if (afterCallback != undefined)
					afterCallback();
			});
		}, timeout);
	}

	softResetBase() {
		this.disableSoftResetButton = true;
		this.receiverService.softReset([this.formData.id]).then(res => {
			this.disableSoftResetButton = false;
		}).catch(error => {
			this.disableSoftResetButton = false;
			var errorText = (error.data.errors as Array<string>).join(" ");
			this.showErrorMessage(errorText);
		});
	}

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	//TODO tohle je i v baseTlTalbe
	lastIdComponent = 0;
	addNewTag(item: any) {
		this.$bvModal.show('tagDialog');
		this.lastIdComponent = Number(item.id);
		(this.$refs.tagModal as TagModal).setSelected(item.tags, this.lastIdComponent, item.name);
	}

	gridColor(color: string): string {
		return 'background-color: ' + color + ';';
	}

	//TODO tohle je i v baseTlTalbe - sjednotit
	changeTagsBase(items: any): void {
		this.formData.tags = items;
	}

	goBackDetailTagBase(item: any): void {
		let tags: any = this.formData.tags;
		if (tags != null) {
			let changeItem = tags.filter((c: any) => c.id == item.id)[0];
			changeItem.name = item.name;
			changeItem.color = item.color;
		}
	}

	tagDetail(item: any): void {
		this.$bvModal.show('detailModal');	
		(this.$refs.detailModal as ModalDetail).setSelected(String(item.id));
	}

	variantList: any[] = [];
	contentImageList: any[] = [];

	objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Receiver;
	getPreviewId(id: number | null | undefined): string {
		return `image_detail_receiver_${id}`;
	}

	public assignTenantBase() {
		this.initAllTenant();
		this.$bvModal.show('tenantModal');
	}

	initAllTenant(): void {
		this.tenantService.getAllByFilter(new TenantFilter(false, true)).then(response => {
			this.tenantsAll = response.data;
		});
	}

	protected selectedTenantItemsBase(items: any): void {
		this.formDataTenant.idTenant = Number(items[0]);
		this.receiverService.updateTenant(this.formData.id, this.formDataTenant).then(res => {
		this.formData.adoptionCode = '';
		}).catch(error => {
			var errorText = (error.data.errors as Array<string>).join(" ");
			this.showErrorMessage(errorText);
		});		
	}

	public showAdoptionCodeBase() {
		return RightHelper.currentUserIsSuperUser() && this.formData.adoptionCode != '' && this.formData.adoptionCode != undefined && this.formData.idTenant == null;
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		this.idFirstImage = JSON.parse(JSON.stringify(this.objectId));
		return this.receiverService.getById(this.objectId);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		this.idFirstImage = JSON.parse(JSON.stringify(this.objectId));
		return this.receiverService.getRefreshById(this.objectId);
	}

	refreshItems(items: any, refreshData: any): any {
		const prevFileSumCheckTable = this.formData.fileSumCheckTable;

		this.formData.idComponentStateNavigationName = refreshData.idComponentStateNavigationName;
		this.formData.taskActual = refreshData.taskActual;
		this.formData.isActive = refreshData.isActive;
		this.formData.connectionState = refreshData.connectionState;
		this.formData.connectionStateError = refreshData.connectionStateError;
		this.formData.fileSumCheckTable = refreshData.fileSumCheckTable;
		this.formData.isDisabled = refreshData.isDisabled;
		this.formData.isProcessingTask = refreshData.isProcessingTask;
		this.formData.idComponentStateNavigationName = refreshData.idComponentStateNavigationName;
		this.formData.idComponentStateNavigationIdentifier = refreshData.idComponentStateNavigationIdentifier;
		this.formData.isWaitingForAcceptProvisioning = refreshData.isWaitingForAcceptProvisioning;

		//console.log('refreshItems', this.formData.fileSumCheckTable, prevFileSumCheckTable);
		if (this.formData.fileSumCheckTable != prevFileSumCheckTable)
		{
			this.imageSwitch(this.objectId);
			this.fetchAfterRefresh();
		}
		return items;
	}

	protected processResponse(response: AxiosResponse<any>): void {
		this.getReceiverDataFromResponse(response.data);
	}

	protected afterUpdate(response: AxiosResponse<any>): void {
		this.fetchData();
	}

	fetchVariantList() {
		let filter: VariantFilter = new VariantFilter(true);
		this.variantService.getAllByFilter(filter).then((response) => {
			this.variantList = [];
			for (var i = 0; i < response.data.length; i++) {					
				this.variantList.push({ value: response.data[i].id, text: response.data[i].name });
			}
		});
	}

	fetchContentImageList() {
		let filter: ContentFilter = new ContentFilter(this.$store.state.idTenant, false, 'ENU_CON_Content_Type_Image');
		this.contentService.getAllByFilter(filter).then((response) => {
			this.contentImageList = [];
			this.contentImageList.push({ value: 0, text: '' });
			for (var i = 0; i < response.data.length; i++) {
				this.contentImageList.push({ value: response.data[i].id, text: response.data[i].name });
			}
		});
	}

	protected getReceiverDataFromResponse(data: any) {
		this.getComponentDataFromResponse(data.component);
		this.formData.fileSumCheckTable = data.fileSumCheckTable;
		this.formData.idTenant = data.idTenant;
		this.formData.isReceiverComponent = data.component.isReceiverComponent;
		this.formData.idVariant = data.idVariant;
		this.formData.idVariantText = data.idVariantText;
		this.formData.idComponent = data.idComponent;
		this.formData.idDisplayOrientation = data.idDisplayOrientation;
		this.formData.idDisplayOrientationText = data.idDisplayOrientationText;
		this.formData.enableDisplayTurnOff = data.enableDisplayTurnOff;
		this.formData.sendPrintScreen = data.sendPrintScreen;
		this.formData.audioEnabled = data.audioEnabled;
		this.formData.idAudioOutput = data.idAudioOutput;
		this.formData.idLogLevel = data.idLogLevel;
		this.formData.idTimeZone = data.idTimeZone;
		this.formData.idContentInBootUpScreen = data.idContentInBootUpScreen;
		this.formData.idContentInBootUpScreenText = data.idContentInBootUpScreenText;
		this.formData.backgroundColor = data.backgroundColor;
		this.formData.taskActual = data.taskActual;
		this.formData.taskCommon = data.taskCommon;
		this.formData.taskPriority = data.taskPriority;
		this.formData.taskIdle = data.taskIdle;
		this.formData.idGroupNavigationName = data.idGroupNavigationName;
		this.formData.tags = data.tags;
		this.formData.idAudioOutputText = data.idAudioOutputText;
		this.formData.idLogLevelText = data.idLogLevelText;
		this.formData.idTimeZoneText = data.idTimeZoneText;
		this.formData.operatingSystem = data.operatingSystem;
		this.formData.connectionState = data.connectionState;
		this.formData.connectionStateError = data.connectionStateError;
		this.formData.dotnet = data.dotnet;
		this.formData.programVersion = data.programVersion;
		this.formData.displayResolution = data.displayResolution;
		this.formData.storage = data.storage;
		this.formData.storageData = data.storageData;
		this.formData.cPU = data.cpu;
		this.formData.cPUTemperature = data.cpuTemperature;
		this.formData.rAM = data.ram;
		this.formData.hardwarePlatform = data.hardwarePlatform;
		this.formData.videoOutput = data.videoOutput;
		this.formData.audioOutput = data.audioOutput;
		this.formData.contentInBootUpScreen = data.contentInBootUpScreen;
		this.formData.dateOfConfiguration = tlISODateTimeToLocalString(data.dateOfConfiguration);
		this.formData.adoptionCode = data.component.adoptionCode;
		this.formData.useCPU = data.useCPU;
		this.formData.uptime = tlResponseToUptimeString(data.uptime);
		this.formData.cECState = data.cecState;
		this.formData.cECStateAllow = data.cecStateAllow;
		this.formData.localTime = tlISOLocalDateTimeToZoneString(data.localTime);
		this.formData.ipaddressLocalText = data.ipaddressLocalText;
	}

	protected getComponentDataFromResponse(data: any) {
		this.formData.cECState = data.cECState;
		this.formData.cECStateAllow = data.cECStateAllow;		
		this.formData.id = data.id;
		this.formData.idGroup = data.idGroup;
		this.formData.componentId = data.componentId;
		this.formData.name = data.name;
		this.formData.description = data.description;
		//VaP - v detailu komponenty nebude zobrazovat informace o receiveru, na to slouzi receiverdetail
		this.formData.isReceiverComponent = false;
		this.formData.idComponentTypeNavigationName = data.idComponentTypeNavigationName;
		this.formData.idComponentStateNavigationIdentifier = data.idComponentStateNavigationIdentifier;
		this.formData.idComponentStateNavigationName = data.idComponentStateNavigationName;
		this.formData.portText = data.portText;
		this.formData.ipaddressText = data.ipaddressText;			
		this.formData.ipaddressVPNText = data.ipaddressVPNText;
		this.formData.macaddress = data.macaddress;
		this.formData.isActive = data.isActive;
		this.formData.isDisabled = data.isDisabled;
		this.formData.isWaitingForAcceptProvisioning = data.isWaitingForAcceptProvisioning;
		this.formData.isLost = data.isLost;
		this.formData.isProcessingTask = data.isProcessingTask;
		this.formData.isDeleted = data.isDeleted;
		this.formData.mtu = data.mtu;
		this.formData.mtuText = data.mtuText;
	}

	protected getComponentDataFromFormData() {
		let formData = Object.assign({},
			{ Id: this.formData.id },
			{ IdGroup: this.formData.idGroup },
			{ ComponentId: this.formData.componentId },
			{ Name: this.formData.name },
			{ Description: this.formData.description },
			{ IdComponentTypeNavigationName: this.formData.idComponentTypeNavigationName },
			{ IdComponentStateNavigationName: this.formData.idComponentStateNavigationName },
			{ PortText: this.formData.portText },
			{ IpaddressText: this.formData.ipaddressText },
			{ IpaddressLocalText: this.formData.ipaddressLocalText },
			{ IpaddressVPNText: this.formData.ipaddressVPNText },
			{ Macaddress: this.formData.macaddress },
			{ IsActive: this.formData.isActive },
			{ IsDisabled: this.formData.isDisabled },
			{ IsWaitingForAcceptProvisioning: this.formData.isWaitingForAcceptProvisioning },
			{ IsLost: this.formData.isLost },
			{ IsProcessingTask: this.formData.isProcessingTask },
			{ IsDeleted: this.formData.isDeleted },
			{ Mtu: this.formData.mtu }
		);
		return formData;
	}

	getFormDataForReceiver(): {} {
		let componentData = this.getComponentDataFromFormData();
		let formData = Object.assign({},
			{ IdComponent: this.formData.idComponent },
			{ IdVariant: this.formData.idVariant },
			{ IdDisplayOrientation: this.formData.idDisplayOrientation },
			{ EnableDisplayTurnOff: this.formData.enableDisplayTurnOff },
			{ SendPrintScreen: this.formData.sendPrintScreen },
			{ AudioEnabled: this.formData.audioEnabled },
			{ IdAudioOutput: this.formData.idAudioOutput },
			{ IdLogLevel: this.formData.idLogLevel },
			{ IdTimeZone: this.formData.idTimeZone },
			{ IdContentInBootUpScreen: this.formData.idContentInBootUpScreen },
			{ BackgroundColor: this.formData.backgroundColor },
			{ Component: componentData }
		);
		return formData;
	}

	doAction() {
		//TOHLE UZ SE NEZOBRAZUJE
		super.doCRUDActionWithInfoMessage(this.$t('receiver.messageNew').toString(), this.$t('receiver.messageEdit').toString(), this.$t('role.messageDelete').toString());
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		if (Number(this.formData.mtu) < 0) {
			this.formData.mtu = null;
		}
		if (Number(this.formData.idGroup) < 0) {
			this.formData.idGroup = null;
		}
		let formDataForReceiver = this.getFormDataForReceiver();
		return this.receiverService.update(this.objectId, formDataForReceiver);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.receiverService.delete(this.objectId);
	}

	showAcceptProvisionButton() {
		return (this.styleFormDetail) && this.formData.isWaitingForAcceptProvisioning && RightHelper.currentUserHasRight('COR_Component_Provisioning') && !this.formIsInEditMode && this.formData.idTenant != null;
	}

	showAssignTenantButton() {
		return (this.styleFormDetail) && this.formData.isWaitingForAcceptProvisioning && RightHelper.currentUserIsSuperUser() && !this.formIsInEditMode && this.formData.idTenant == null;
	}

	showActivateButton() {
		return (this.styleFormDetail) && this.formData.isDisabled && this.canUpdate && !this.formIsInEditMode;
	}

	showDeactivateButton() {
		return (this.styleFormDetail) && this.formData.isActive && this.canUpdate && !this.formIsInEditMode;
	}

	showStopProcessingTaskOnComponentButton() {
		return (this.styleFormDetail) && this.formData.isProcessingTask && this.canUpdate && !this.formIsInEditMode;
	}

	acceptProvisionComponent() {
		super.callActionAndShowErrorInfoMessage(this.componentService.acceptProvision(this.objectId), this.$t('receiverDetail.receiverAdd').toString(),true);
	}

	activateComponent() {
		super.callActionAndShowErrorInfoMessage(this.componentService.activateComponent(this.objectId), this.$t('receiverDetail.receiverActivate').toString(),true);
	}

	deactivateComponent() {
		super.callActionAndShowErrorInfoMessage(this.componentService.deactivateComponent(this.objectId), this.$t('receiverDetail.receiverDeactivate').toString(),true);
	}

	stopTask() {
		super.callActionAndShowErrorInfoMessage(this.componentService.stopTask(this.objectId), this.$t('receiverDetail.taskStop').toString(),true);
	}

	playTaskOnComponent() {
		super.callActionAndShowErrorInfoMessage(this.componentService.playProcessingTaskOnComponent(this.objectId), this.$t('receiverDetail.receiverPlay').toString(), true);
	}

	stopProcessingTaskOnComponent() {
		super.callActionAndShowErrorInfoMessage(this.componentService.stopProcessingTaskOnComponent(this.objectId), this.$t('receiverDetail.receiverStop').toString(),true);
	}

	vIsCorrectName: boolean = true;
	vIsCorrectComponentId: boolean = true;

	validateBase() {
		return !(this.vIsCorrectName && this.isCorrectComponentIdBase);
	}

	isCorrectNameBase(value: any) {
		this.vIsCorrectName = value;
	}

	isCorrectComponentIdBase(value: any) {
		this.vIsCorrectComponentId = value;
	}

	createdBase() {
		this.showParamsDetail = this.$store.state.showDetailParamFirstShow;			
		if (this.$route.query.goBack != undefined) {
			this.returnRoute = this.$route.query.goBack as string;
		}
	}

	fieldsTenantModal = [
		{ key: 'identifier', label: this.$t('tenant.fieldIdentif'), trans: 'tenant.fieldIdentif', sortable: true, class: 'text-center', optional: false },
		{ key: 'name', label: this.$t('tenant.fieldName'), trans: 'tenant.fieldName', sortable: true, class: 'text-center', visible: true, optional: false },
		{ key: 'description', label: this.$t('tenant.fieldDescription'), trans: 'tenant.fieldDescription', sortable: true, class: 'text-center', visible: true, optional: false },
		{ key: 'creationDate', label: this.$t('tenant.fieldDate'), trans: 'tenant.fieldDate', sortable: true, class: 'text-center ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: true, optional: false },

	];

	filtersTenantModal = [
		{ key: 'identifier', label: this.$t('tenant.filterIdentif'), trans: 'tenant.filterIdentif', selected: false, value: null, type: 'text', refItem: 'identifier' },
		{ key: 'name', label: this.$t('tenant.filterName'), trans: 'tenant.filterName', selected: true, value: null, type: 'text', isEditable: true },
		{ key: 'description', label: this.$t('tenant.filterDescription'), trans: 'tenant.filterDescription', selected: false, value: null, type: 'text' },
	];

	historyMessageAll: [] = [];
	showHistoryMessageModal() {
		this.initMessageHistory();
		this.$bvModal.show('historyMessageModal');
	}

	cancelComponentMessage(item: any) {
		this.messageService.cancelMessage(Number(item.id), null).then(res => {
			(this.historyMessageAll.filter((c: any) => c.id == item.id)[0] as any).allowDelete = false;
			(this.historyMessageAll.filter((c: any) => c.id == item.id)[0] as any).isCanceledText = "Ano";
		});
	}

	protected initMessageHistory(): void {
		this.isBusy = true;
		//TODO zmenit
		let messageFilter: MessageFilter = new MessageFilter(this.formData.idComponent);
		this.messageService.getAllByFilter(messageFilter).then(response => {
			this.historyMessageAll = response.data;
			this.prepareItemsForModal(this.historyMessageAll);
			this.isBusy = false;
		});
	}

	protected prepareItemsForModal(items: any[]) {
		for (var i = 0; i < items.length; i++) {
			items[i].creationDateTo = items[i].creationDate;
			items[i].receiveDateTo = items[i].receiveDate;
			items[i].isCanceledText = this.$t(checkBoxToString(items[i].isCanceled)).toString();
		}
	}

	fieldsMessageHistoryModal = [
		//{ key: 'id', label: 'id', trans: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
		{ key: 'idMessageTypeText', label: this.$t('component.messageFieldType'), trans: 'component.messageFieldType', sortable: true, sortDirection: 'asc', class: 'text-center' },
		{ key: 'creationDate', label: this.$t('component.messageFieldCreated'), trans: 'component.messageFieldCreated', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
		{ key: 'receiveDate', label: this.$t('component.messageFieldAccepted'), trans: 'component.messageFieldAccepted', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
		{ key: 'sendAttemptCountText', label: this.$t('component.messageFieldCount'), trans: 'component.messageFieldCount', sortable: true, sortDirection: 'asc', class: 'text-center' },
		{ key: 'isCanceledText', label: this.$t('component.messageFieldCountCanceled'), trans: 'component.messageFieldCountCanceled', sortable: true, sortDirection: 'asc', class: 'text-center' },


		{ key: 'sendDate', label: this.$t('component.messageFieldSend'), trans: 'component.messageFieldSend', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), optional: true, visible: false },
		{ key: 'nextSendDate', label: this.$t('component.messageFieldNextSendDate'), trans: 'component.messageFieldNextSendDate', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), optional: true, visible: false },
		{ key: 'body', label: this.$t('component.messageFieldBody'), trans: 'component.messageFieldBody', sortable: false, sortDirection: 'asc', class: 'text-center', optional: true, visible: false },

		{ key: 'actions', label: this.$t('component.messageFieldAction'), sortable: false, class: 'text-right' },
	];

	itemsAnswer = [
		{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
		{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }
	];

	filtersMessageHistoryModal = [
		{ key: 'creationDateTo', label: this.$t('component.messageFieldCreated'), trans: 'component.messageFieldCreated', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'creationDate' },
		{ key: 'receiveDateTo', label: this.$t('component.messageFieldAccepted'), trans: 'component.messageFieldAccepted', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'receiveDate' },
		{ key: 'isCanceledText', label: this.$t('component.messageFieldCountCanceled'), trans: 'component.messageFieldCountCanceled', selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsAnswer },
	];

	isFirstTime = true;
	prepareFilters() {		
		if (this.isFirstTime) {
			var taskStateEnums = { key: 'ENU_COR_Message_Type', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idMessageTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('component.messageFieldType'), trans: 'component.messageFieldType', isNegative: true };
			this.loadFiltersEnumListModal([taskStateEnums], this.filtersMessageHistoryModal);
			this.isFirstTime = false;			
		}
		return this.filtersMessageHistoryModal;
	}

	//@ts-ignore
	@Watch('$store.state.currentLanguage')
	changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
		if (this.$route != null && this.$route.name != null && this.$route.query !=null) {
			//kvuli dropDown listum je potreba tvrdy refresh
			var nameDes = this.$route.name as String;

			var query = this.$route.query;
			this.$router.push({ name: 'helpRefresh', query: query }).then(c => {
				this.$router.push({ name: nameDes + '', params: this.$route.query as any, query: query });
			});
		}
	}
}
